
import { v4 as uuidv4 } from 'uuid';
import { randomstring } from './util';
const DOMAIN = 'npdng.org';
const DOMAIN_PROD = 'naepnpd.org'
const PROTOCOL = "https://";
const ENAEP_ONLINE = 'enaep';
const ENAEP_ONLINE_API = 'api';
const ENAEP_ONLINE_ENTRY = 'login/index.html';
const DEFAULT_ENV = "dev24";
const appLaunchDateTime = new Date().toDateString();
let appLaunchId = undefined;
let deviceID = undefined;
let assessmentUrl = undefined;
let setUpCode = undefined;
let locale = undefined;
let deliveryMode = undefined;
let ncsDomain = undefined;
let ncsDetails = undefined;
let currentNetworkConnectionType = "offline";
let localIPAddress = undefined;
let networkInformation = undefined;
let chromeExtensionVersion = "extension not available";
//http://localhost:3000/?mode=router&ncs=192.168.15.68

const getncsDomain = ()=> {
    const urlParams = new URLSearchParams(window.location.search);
    const ncs4Param = urlParams.get('ncs');
    const ncs = ncs4Param
    if(ncsDomain){
        return ncsDomain;
    }
    else if(ncs){
        return ncs;
    }
    else {
        return 'ncs.local'
    }
}

const deviceValidationTasks = {
       checkBattery : {
            enabled: true,
            name: "checkBattery",
            threshold: 0.5,
            type: "0"
        },
        checkConnection : {
            enabled: false,
            name: "checkConnection",
            threshold: "connected",
            type: "0"
        },
       checkCPU : {
            enabled: true,
            name: "checkCPU",
            threshold: "70",
            type: "0"
        },
    
       checkMemory : {
            enabled: true,
            name: "checkMemory",
            threshold: 2000000000,
            type: "1"
        },
        checkVersion : {
            enabled: false,
            name: "checkVersion",
            threshold: undefined,
            type: "1"
        },
    
      checkCloudServerHealth : {
            enabled: true,
            name: "checkCloudServerHealth",
            threshold: "200",
            type: "1"
        },
        checkNCSServerHealth: {
            enabled: true,
            name: "checkNCSServerHealth",
            threshold: "200",
            type: "1"
        },
        stressTest: {
            enabled: true,
            name: "stressTest",
            threshold: undefined,
            type: "1"
        },
        checkSystemClock:{
            enabled: true,
            name: "checkSystemClock",
            threshold: 300000,
            type: "1" 
        }
}

let getNCServices =() => {
    return {
        "startUrl":`https://${getncsDomain()}:4010/sci?lcs_api_url=${getncsDomain()}:4011`,
        "adsServices":`https://${getncsDomain()}:4011`,
        "sdsServices":`https://${getncsDomain()}:4060`,
        "adminServices":`https://${getncsDomain()}:4080`
    }
   
};

const CONTENT = {
    "version": "24.0.0-MS2.0.3",
    "versionColors": [
        "#e7ffe1",
        "#ffece1",
        "#e1f9ff",
        "#fdffe1",
        "#b7ffcb",
        "#f0e1ff",
        "#ffe3aa",
        "#d8e4ec",
        "#9cff84",
        "#ffb6a2",
        "#eeb9ff",
        "#fbff73",
        "#cdcfff",
        "#e8dada",
        "#a2ecbc",
        "#ffa5cc"
    ],
    "versionBorderColors": [
        "#00cd0b",
        "#cdcfff",
        "#4a9f67",
        "#a7b600",
        "#00a52e",
        "#ab6fe6",
        "#a58547",
        "#517e9f",
        "#25ba00",
        "#f53b00",
        "#9d00c4",
        "#aeb200",
        "#3b43ff",
        "#a75050",
        "#4a9f67",
        "#c03670"
    ],
    "assessmentLaunchModes": ["online","ncs"],
    "showDeviceReadinessResults": {
        device: true,
        launchMode:true,
        stressTest:true
    },
    "setupCode":{
        "setupCodeLength": 4 
    }
   
}

const adminBoxConfig = {
    "domain":"npdng.org",
    "setupCodeLength": 4,
    "setupCode": {
        "title": "Setup Code",
        "errorText": "You have entered an invalid code. Please try again.",
        "connecting": "Verifying your Setup Code please wait..."
    },
    "actions": {
        "tryAgain": "Try Again",
        "cancel": "Cancel",
        "exit": "Exit Application",
        "goBack": "Go Back",
        "shutdown": "Shut Down Device",
        "close": "Close Assessment",
        "resume": "Resume",
        "submit": "Submit",
        "tryagain": "Try Again",
        "skipStressTest": "Skip Network Readiness check",
        "modeSelect": "Select a different mode",
        "launchAssessment": "Launch Assessment",
        "skipToNextBlock": "Skip to Next Block"
    },
    "notifications": {
        "updateChecking": "Checking for available updates...",
        "updateNotFoundTitle": "You're up to date",
        "updateNotFoundSubTitle": "Your device has the latest version of the eNAEP application.",
        "updateNotFoundRedirection": "You will be automatically redirected in ",
        "updatesAvailableTitle": "Updates are available",
        "updatesReadyTitle": "Preparing device for update",
        "updatesEstimatedTimeText": "This process may take several minutes to complete.",
        "updateStart": "Download will begin automatically in ",
        "updateDownload": "Downloading...",
        "updateInstall": "Installing...",
        "updatePrep": "Preparing updates for installation...",
        "updateDelay": "We are still working on the update. It took longer than we expected.",
        "doNotCloseAppWarn": "Please do not close this application.",
        "wait": "Please wait...",
        "internetConnecting": "Connecting...",
        "restartInfo": "This application will restart momentarily so that changes can be applied.",
        "exitingApplication": "Exiting Application...",
        "defaultErrorHeading": "Error - System Error",
        "defaultErrorDetails1": " An error has been encountered and the application has stopped working.",
        "defaultErrorDetails2": "Select",
        "defaultErrorDetails3": "Exit Application",
        "defaultErrorDetails4": "to quit and try again.",
        "defaultErrorDetails5": "You will need to restart the application from the desktop.",
        "defaultErrorDetails6": "If the problem persists, please ask a member of the NAEP Support Team for assistance.",
        "ncsSearch": "Connecting To NAEP Classroom Server"
    },
    "adminAccessBox": {
        "header": {
            "status": "Assessment status:",
            "student": "Student Id:"
        },
        "warning": {
            "title": "Administrator Access",
            "description1": "Please select ",
            "description2": " Go Back ",
            "description3": " if you did not mean to open this page.",
            "proceed1": "Admins Only",
            "proceed2": " - Proceed to Admin Access"
        },
        "login": {
            "title": "Administrator Access",
            "description": "Setup Code",
            "placeholder": "(Admins Only) Enter Setup Code",
            "invalid1": "Invalid Setup Code.",
            "invalid2": "Please try again or contact the NAEP Help desk."
        },
        "dashboard": {
            "title": "Administrator Access",
            "description": "Please select from the following options: ",
            "defaultSelect": "Select...",
            "returnLink": "Return to Assessment",
            "returnMsg": "(Safely close this window and return to the Assessment)",
            "actions": {
                "close": {
                    "action": "Exit Assessment",
                    "description": "Closes this device's Assessment in-progress and returns to the Mode Selection screen."
                },
                "shutDown": {
                    "action": "Shut Down Device",
                    "description": "Exits this device's Assessment in-progress and shuts down the device."
                },
                "refresh": {
                    "action": "Refresh Screen",
                    "description": "Refreshes the browser. Reloads the page and returns the student to the last screen they were viewing."
                },
                "resume": {
                    "action": "Resume(Assessment Paused)",
                    "description": "Safely closes this window and resumes this device’s Assessment in-progress."
                },
                "release": {
                    "action": "Release from Waiting Room",
                    "description": "Releases this device from the Waiting Room. Enables the student to freely start the Assessment."
                },
                "skipToNextBlock": {
                    "action": "Advance Student",
                    "description": "Automatically advances the student to the next section of the Assessment in-progress."
                }
            }
        }
    }
}

const config = {
    NT_TIMEOUT : 10000,
    HEARTBEAT_INTERVAL:10000,
    DELAY_REDIRECT_SEC: 15,
   //support ability to launch the app in the browser for local development without depending on the extension and router connection
   //http://localhost:3000/?mode=router&ncs=192.168.15.68  
   getOnlineStatus:()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const mode4Param = urlParams.get('mode');
        const mode = mode4Param; 
        const onlineStatus = window.navigator.onLine ? mode && mode === "router" ? "router" : "internet" : "offline";
        return onlineStatus;     
    },
    getAppLaunchDateTime:()=>{
        return appLaunchDateTime;
    },
    setNCSDomain : (_ncsDomain)=>{
        ncsDomain = _ncsDomain
    },
    setNCSDetails: (_ncsDetails) =>{
        ncsDetails = _ncsDetails;  
    },
    getNCSDetails: ()=>{
      return ncsDetails;  
    },
    setChromeExtensionVersion:(_chromeExtensionVersion)=>{
        chromeExtensionVersion = _chromeExtensionVersion;
    },
    getChromeExtensionVersion:()=>{
        return chromeExtensionVersion;
    },
    setNetworkInformation:(_networkInformation)=>{
     networkInformation = _networkInformation;
    },
    getNetworkInformation:()=>{
     if(networkInformation){
         return networkInformation
     }
     else {
         return navigator.connection;
     }   
    },
    getCurrentNetworkConnectionType: ()=>{
        if(currentNetworkConnectionType){
            return window.navigator.onLine ? "internet" : "offline";
        }
        else {
            return currentNetworkConnectionType;   
        }
    },
    setCurrentNetworkConnectionType: (_currentNetworkConnectionType)=>{
        currentNetworkConnectionType = _currentNetworkConnectionType;   
       },
    getSessionDataAndConfig: ()=>{
        const endpoint = `${PROTOCOL}${ENAEP_ONLINE_API}.${ENAEP_ONLINE}.${env}.${domain}`;
        return {
            verifySetUpCodeOnlineAPI: `${endpoint}${API.verifySetUpCode}`,
            participantCommandOnlineAPI:`${endpoint}${API.participantCommand}`,
            participantStatusOnlineAPI: `${endpoint}${API.participantStatus}`,
            verifySetUpCodeNCSAPI: `${getNCServices().adsServices}${API.verifySetUpCode}`,
            participantCommandNCSAPI:`${getNCServices().sdsServices}${API.participantCommand}`,
            participantStatusNCSAPI: `${getNCServices().sdsServices}${API.participantStatus}`,
            setUpCode: config.getSetupCode(),
            deviceId: config.getDeviceID(),
            deliveryMode:config.getDeliveryMode(),
            appLaunchId: config.getLaunchID(),
            adminBoxConfig: adminBoxConfig,
            appVersion:config.getContent().version,  
            localIPAddress: config.getLocalIPAddress(),
            ncsDetails: config.getNCSDetails(),
            appLaunchDateTime: config.getAppLaunchDateTime()
        }
    },
    getEnvironment: ()=>{
        let loc = window.location.href.split(".")
        let env = loc.length > 1  ? loc[1] : DEFAULT_ENV;
        if (window.location.href.includes('127.0')){
            env = DEFAULT_ENV;
        }
       
        console.log(`[Config][get environmnet][current environment: ${env}]`);
        return env; 
    },
    getDomain:()=>{
        const env = config.getEnvironment();
        if(env.indexOf("stage")>-1 || env.indexOf("prod")>-1 || env.indexOf("test")>-1 ){
            return DOMAIN_PROD;
        }
        else {
            return DOMAIN
        }
    },
    getOnlineURI: () =>{
       return `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/${ENAEP_ONLINE_ENTRY}`;
    },
    getNCSURI: ()=>{
        return getNCServices().startUrl;
    },
    getOnlineAPI:()=>{
        const endpoint = `${PROTOCOL}${ENAEP_ONLINE_API}.${ENAEP_ONLINE}.${env}.${domain}`;
        return {
            verifySetupCode:`${endpoint}${API["verifySetUpCode"]}`,
            postDeviceMetrics:`${endpoint}${API["postDeviceMetrics"]}`,
            healthUrl: `${endpoint}${API["cloudServiceHealth"]}`,
            postHeartbeat:`${endpoint}${API["heartbeat"]}`,
            postHeartbeatAsync:`${endpoint}${API["heartbeatAsync"]}`,
            participantCommand:`${endpoint}${API["participantCommand"]}`,
            getSignedUrl: `${endpoint}${API["dataTransfer"]["sign"]}`,
            deviceStatus:`${endpoint}${API["deviceStatus"]}`,
            ping: `https://api-speedtest-nonprod.npdng.org/speed-test/ping`,
            getApplicationVersion: `${endpoint}${API["getVersion"]}`
        }
        },  
    getNCSAPI:()=>{
        return {
            verifySetupCode:`${getNCServices().sdsServices}${API["verifySetUpCode"]}`,
            postDeviceMetrics:`${getNCServices().adsServices}${API["postDeviceMetrics"]}`,
            postHeartbeat:`${getNCServices().adsServices}${API["heartbeat"]}`,
            postHeartbeatAsync:`${getNCServices().adsServices}${API["heartbeatAsync"]}`,
            healthUrl: `${getNCServices().adminServices}${API["NCSServererHealth"]}`,
            participantCommand: `${getNCServices().sdsServices}${API["dataTransfer"]}`,
            getSignedUrl: `${getNCServices().adminServices}${API["dataTransfer"]["sign"]}`
        }
     },
    getStressTestConfig:()=>{
        return stressTestConfig;
    },
    getDeviceValidationTasks:()=>{
        return deviceValidationTasks
    } , 
    getContent:()=>{
        return CONTENT;
    },
    getLaunchID: ()=>{
        if(!appLaunchId){
            appLaunchId = uuidv4();
        }
        return appLaunchId;
    },
    getDeviceID: ()=>{
        if(!deviceID){
            deviceID =  `CB${randomstring(4).toUpperCase()}`;
        }
        return deviceID
    },
    setDeviceId:(_deviceId)=>{
        deviceID = _deviceId;  
    },
    getLocalIPAddress: ()=>{
        if(!localIPAddress){
            localIPAddress =  "127.0.0.1";
        }
        return localIPAddress
    },
    setLocalIPAddress:(_localIPAddress)=>{
        localIPAddress = _localIPAddress;  
    },
    setSetupCode: (code)=>{
        setUpCode = code;
    },
    getSetupCode: ()=>{
        return setUpCode?.toUpperCase();
    },
    setLocale: (_locale)=>{
        locale = _locale;
    },
    getLocale: ()=>{
        return locale;
    },
    setDeliveryMode: (mode)=>{
        deliveryMode = mode;
    },
    getDeliveryMode: ()=>{
        return deliveryMode;
    },
    setAssessmentUrl:(url)=>{
        assessmentUrl=url;
    },
    getAssessmentUrl:()=>{
        return assessmentUrl;
    }
}
const env =  config.getEnvironment();
const domain =config.getDomain();
const stressTestConfig = {
    "enabled": true,
    "executionTime": 60000,
    "classroomSyncronizationTimeout": 110000,
    "sleepIntervalBetweenSets": 3000,
    "minRequiredDownloadSpeedKbps": 200,
    "minRequiredUploadSpeedKbps": 200,
    "minSuccessRateinSets": 1,
    "uploadPropertyCount": 500,
    "maxFailurePercentage": 20,
    "eventDataType": "static",
    "adjustmentCoefficient": 4.5,
    "files": {
        "download": [
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_1.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_2.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_3.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_4.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_5.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_6.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb+7.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_8.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_9.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_10.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_11.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_12.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_13.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_14.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_15.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_16.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_17.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_18.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_19.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_20.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_21.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_22.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_23.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_24.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_25.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            {
                "url": `${PROTOCOL}${ENAEP_ONLINE}.${env}.${domain}/adp-chrome-app/stress-test/test_24mb_26.bytes`,
                "timeoutinMs": 15000,
                "checksum": "",
                "fileSize": 1000
            },
            
        ]
    }
}
const API = {
    verifySetUpCode: "/v1/student-data-services/assessment/schools/verify",
    cloudServiceHealth:"/session-service/health",
    NCSServererHealth:"/health",
    sdsHealth: "/v1/student-data-services/health",
    postDeviceMetrics:`/classroom-data-service/device-metrics/${config.getLaunchID()}`,
    heartbeat:`/classroom-data-service/heartbeat`,
    heartbeatAsync:`/classroom-data-service/heartbeat/async`,
    participantCommand: '/v2/student-data-services/assessments/sessions/participants/command',
    participantStatus: "/v2/student-data-services/assessments/sessions/participants/status",
    deviceStatus:"/v2/student-data-services/assessments/sessions/devices/status",
    getVersion: `/configuration-service/software/update`,
    dataTransfer:{
        sign: '/data-service/data-transfer/sign',
        put:'/data-service/data-transfer',
        status:'/data-service/data-transfer/status'
    }
}

export default config;
